<template>
  <div>
    <div>
      <div class="form-area">
        <div class="input-wrap show-error">
          <p v-if="errorMessage" class="field-error">{{errorMessage}}</p>
          <div v-if="!uploading && !uploaded" class="file-wrap">
            <input type="file" name="image" class="file-upload" @change="handleImage" accept="image/*">
            <span>Choose File</span>
          </div>
        </div>
        <div id="preview-holder" v-if="image.name">
          <p v-if="image.name">
            {{ image.name }}
            <img v-if="uploading" class="spinner" src="@/images/spinner.gif" width="35px" alt="">
            <img v-if="uploaded" class="check" src="@/images/yellow_check@2x.png" width="19px" alt="">
          </p>
          <div v-if="image.url">
            <img class="preview" :src="image.url">
            <button type="button" class="plain link" @click="clearImage">Remove</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'image-upload',
  data () {
    return {
      image: {
        url: '',
        name: ''
      },
      uploading: false,
      uploaded: false,
      errorMessage: ''
    }
  },
  created: function () {
  },
  methods: {
    handleImage: function (event) {
      if (this.uploading) return
      this.errorMessage = ''
      const input = event.target
      if (input.files && input.files[0]) {
        this.filterImage(input.files[0]).then(() => {
          this.image.name = input.files[0].name
          this.uploadImage(input.files[0])
        })
      }
    },
    uploadImage: function (imageFile) {
      this.$emit('imageUploading')
      this.uploading = true
      const formData = new FormData()
      formData.append('image', imageFile)
      this.$http.post(this.ENV.coreBaseUrl + '/supportImageUpload', formData, {
        headers: { 'content-type': 'multipart/form-data' }
      }).then((response) => {
        if (response.data.imageUrl) {
          this.$emit('imageResponse', response.data.imageUrl)
          this.image.url = response.data.imageUrl
          this.uploaded = true
        } else {
          this.errorMessage = 'Grr...There was an issue uploading your image.'
          this.clearImage()
        }
        this.uploading = false
      }).catch(() => {
        this.errorMessage = 'Grr...There was an issue uploading your image.'
        this.uploading = false
        this.clearImage()
      })
    },
    filterImage: function (imageFile) {
      return new Promise((resolve, reject) => {
        const type = imageFile.type.split('/')[1]
        const size = imageFile.size
        if ('jpg|png|jpeg|bmp|gif'.indexOf(type) !== -1) {
          if (size <= 2000000) {
            resolve()
          } else {
            this.errorMessage = 'File size must not exceed 2MB.'
          }
        } else {
          this.errorMessage = 'Valid image file types include jpg/jpeg, png, bmp, and gif.'
        }
      })
    },
    clearImage: function () {
      this.image.url = ''
      this.image.name = ''
      this.uploaded = false
      this.$emit('imageResponse', false)
    }
  }
}
</script>

<style scoped lang="stylus" src="./image-upload.styl" >
